import { Content } from './zone.styled';

export const Zone = (props) => {
  const { color, zoneId, ...rest } = props;

  return (
    <Content className="zone-icon" style={{ backgroundColor: color }} {...rest}>
      <b>{zoneId}</b>
    </Content>
  );
};
